import Projects from "../Projects/Projects";

const responsiveProjectsList = [
  {
    id: "foodMunch",
    displayText: "Food Munch",
    imageUrl:
      "https://d1tgh8fmlzexmh.cloudfront.net/ccbp-responsive-website/foodmunch-banner-bg.png",
    gitHubUrl: "https://github.com/harikrishnaalvala/food-munch.git",
    liveDemoUrl: "https://ahkfood.ccbp.tech/",
  },
  {
    id: "ecommerce",
    displayText: "Ecommerce",
    imageUrl:
      "https://res.cloudinary.com/dhaj9wlmu/image/upload/v1704077232/Screenshot_2024-01-01_081414_bupe5l.png",
    gitHubUrl: "https://github.com/harikrishnaalvala/ecommerce.git",
    liveDemoUrl: "https://hkflyecommerce.ccbp.tech/",
  },
];

const ResponsiveProjects = () => (
  <Projects projectsList={responsiveProjectsList} />
);

export default ResponsiveProjects;
